
export default function Services() {
  const services = [
    {
      icon: 'ri-time-line',
      title: 'Samme-dag Levering',
      description: 'Hurtig levering samme dag fra Århus til hele Danmark. Professionel håndtering med garanteret levering.',
      features: ['SMS opdateringer', 'Garanteret levering']
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Ekspres Transport',
      description: 'Akut transport når det haster. Vores erfarne kurører sikrer hurtig og sikker levering.',
      features: ['1-2 timers levering', 'Prioriteret håndtering', 'Direkte transport', '10 års erfaring']
    },
    {
      icon: 'ri-building-line',
      title: 'Erhvervslevering',
      description: 'Skræddersyede løsninger til erhvervskunder. Faste aftaler og pålidelig service fra Århus.',
      features: ['Faste månedspriser', 'Dedikeret kontaktperson', 'Fakturering', 'Volumenrabatter']
    },
    {
      icon: 'ri-truck-line',
      title: 'Standard Levering',
      description: 'Pålidelig levering næste dag. Professionel kvalitet med fokus på sikkerhed og pålidelighed.',
      features: ['Næste-dag levering', 'Forsikret transport', 'Konkurrencedygtige priser', 'Pålidelig service']
    }
  ];

  const handleServiceBooking = () => {
    // Scroll til booking formularen
    const bookingForm = document.querySelector('#hurtig-booking');
    if (bookingForm) {
      bookingForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Professionel Kurérservice fra Århus
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Fra vores base i Århus leverer vi professionel kurérservice til hele Danmark. 
            10 års erfaring med fokus på hastighed og pålidelighed.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-medium">
            <i className="ri-award-line"></i>
            Hurtig og pålidelig service siden 2014
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-6 border border-gray-100">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-teal-600 text-2xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6 text-sm leading-relaxed">{service.description}</p>

              <ul className="space-y-2 mb-6">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-teal-500 mr-2 text-base"></i>
                    {feature}
                  </li>
                ))}
              </ul>

              <button 
                onClick={handleServiceBooking}
                className="w-full bg-teal-600 text-white py-3 px-4 rounded-lg hover:bg-teal-700 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer"
              >
                Book Nu
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-teal-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Århus-baseret</h4>
              <p className="text-gray-600 text-sm">Centralt placeret for optimal dækning af hele Danmark</p>
            </div>
            
            <div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-speed-line text-teal-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Hurtig Service</h4>
              <p className="text-gray-600 text-sm">Ekspres levering og samme-dag service når det haster</p>
            </div>
            
            <div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-teal-600 text-2xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">10 Års Erfaring</h4>
              <p className="text-gray-600 text-sm">Professionel faglighed og pålidelig service siden 2014</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
